module.exports = __webpack_public_path__ + "static/influencer-b74c74eca43c635d58ed05a1da22c4df.jpg";